/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:53:19+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AButtonIconCalendar from './AButtonIconCalendar';
import SlideInTransitionGroup from './../../../transitions/SlideIn';


const ICON_PREVIOUS_BUTTON = 'chevron-left';
const ICON_NEXT_BUTTON = 'chevron-right';

/**
 * MToolbarCalendar - …
 */
class MToolbarCalendar extends Component {
    state = {
      transitionDirection: 'up',
    };

    /**
     * react lifecycle componentWillReceiveProps() <MToolbarCalendar>
     *
     * @param {object} nextProps
     * @return {undefined}
     */
    componentWillReceiveProps(nextProps) {
      if (nextProps.displayDate !== this.props.displayDate) {
        const direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
        this.setState({
          transitionDirection: direction,
        });
      }
    }

    /**
     * react render() <MToolbarCalendar>
     *
     * @return {object}
     */
    render() {
      const {displayDate, onPressTitle} = this.props;
      const dateTimeFormatted = `${moment(displayDate).format('MMMM')} ${moment(displayDate).format('YYYY')}`;

      return (
        <div className="m-tooblar m-toolbar-calendar">
          <AButtonIconCalendar
            disabled={!this.props.prevMonth}
            onPress={this.handleOnPressPrevMonth}
          >
            {ICON_PREVIOUS_BUTTON}
          </AButtonIconCalendar>
          <SlideInTransitionGroup
            direction={this.state.transitionDirection}
            className="m-toolbar-calendar__container"
          >
            <div
              key={dateTimeFormatted}
              className="m-toolbar-calendar__title"
              onClick={onPressTitle}
            >
              {dateTimeFormatted}
            </div>
          </SlideInTransitionGroup>
          <AButtonIconCalendar
            disabled={!this.props.nextMonth}
            onPress={this.handleOnPressNextMonth}
          >
            {ICON_NEXT_BUTTON}
          </AButtonIconCalendar>
        </div>
      );
    }


    handleOnPressPrevMonth = () => {
      if (this.props.onMonthChange && this.props.prevMonth) this.props.onMonthChange(-1);
    };


    handleOnPressNextMonth = () => {
      if (this.props.onMonthChange && this.props.nextMonth) this.props.onMonthChange(1);
    };
}
MToolbarCalendar.propTypes = {
  displayDate: PropTypes.instanceOf(Date).isRequired,
  nextMonth: PropTypes.bool,
  prevMonth: PropTypes.bool,
  /**
     * passes the direction of change (-1 || 1)
     */
  onMonthChange: PropTypes.func,
  /**
     * fired when the title with month and year is pressed
     */
  onPressTitle: PropTypes.func,
};
MToolbarCalendar.defaultProps = {
  displayDate: new Date(),
  nextMonth: true,
  prevMonth: true,
};
export default MToolbarCalendar;

